/** Where the live "players online" count comes from. */
export interface PresenceSource {
  /** Players online now, or null when the metric isn't available. */
  getPlayersCount(): Promise<number | null>;
}

export const STUB_PLAYERS_COUNT = 12438;

/** Stub: a fixed count. Replaced by the live players API in ENG-825. */
export const stubPresenceSource: PresenceSource = {
  getPlayersCount: async () => STUB_PLAYERS_COUNT,
};
